// import React from "react";

// const CAPCertificate = () => {
//   return (
//     <div className="flex justify-center px-4 py-10 bg-white">
//       <div className="w-full lg:w-[90%] max-w-6xl">
//         <h2 className="text-3xl font-bold mb-3 text-gray-800">CAP Membership Certificate</h2>
//         <h3 className="text-xl font-semibold mb-2 text-teal-700">
//           Constructors Association of Pakistan (CAP)
//         </h3>
//         <p className="text-gray-700 mb-8">
//           <strong>PACIFIC BUILDERS (PVT) LTD</strong> is a registered associate member of CAP.
//           Membership No: <strong>CAP-1768</strong> | Valid till: <strong>31st March 2026</strong>.
//         </p>
//         <img
//           src="/images/Cap_page-0001.jpg"
//           alt="CAP Certificate"
//           className="w-full rounded-lg shadow-lg"
//         />
//       </div>
//               {/* Certificate Images */}

//       <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//           <img
//             src="/images/Pacific Builders Profile_pages-to-jpg-0039.jpg"
//             alt="PEC License Certificate 1"
//             className="w-full rounded-lg shadow-md"
//           />
//           <img
//             src="/images/Pacific Builders Profile_pages-to-jpg-0039.jpg"
//             alt="PEC License Certificate 2"
//             className="w-full rounded-lg shadow-md"
//           />
//         </div>
//     </div>
//   );
// };

// export default CAPCertificate;


import React from "react";

const CAPCertificate = () => {
  return (
    <div className="flex justify-center px-4 py-10 bg-white">
      <div className="w-full lg:w-[90%] max-w-6xl">
        {/* Heading */}
        <h2 className="text-3xl font-bold mb-3 text-gray-800">CAP Membership Certificate</h2>
        <h3 className="text-xl font-semibold mb-2 text-teal-700">
          Constructors Association of Pakistan (CAP)
        </h3>
        <p className="text-gray-700 mb-8">
          <strong>PACIFIC BUILDERS (PVT) LTD</strong> is a registered associate member of CAP.
          Membership No: <strong>CAP-1768</strong> | Valid till: <strong>31st March 2026</strong>.
        </p>

        {/* Main Image - Office or Building */}
        <div className="mb-8">
        <img
          src="/images/Cap_page-0001.jpg"
          alt="CAP Certificate"
          className="w-full rounded-lg shadow-lg"
        />
        </div>

        {/* Certificate Images */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <img
            src="/images/Cap-Card.jpg"
            alt="PEC License Certificate 1"
            className="w-full rounded-lg shadow-md"
          />
          <img
            src="/images/Cap-Card2.jpg"
            alt="PEC License Certificate 2"
            className="w-full rounded-lg shadow-md"
          />
        </div>
      </div>
    </div>
  );
};

export default CAPCertificate;